// src/store/index.js
import { createStore } from "vuex";
import user from "./user";
import shared from "./shared";

const store = createStore({
  modules: {
    user,
    shared,
  },
});

export default store;

// import Vue from 'vue'
// import Vuex from 'vuex'

// // import events from './events'
// import user from './user'
// import shared from './shared'

// Vue.use(Vuex)
// export const store = new Vuex.Store({
//   modules: {
//     user: user,
//     shared: shared
//   }
// })
